// Central content + config for Tropical Vanilla Co.

export const WHATSAPP_NUMBER = "6287786285954"; // +62 877 8628 5954
export const WHATSAPP_DISPLAY = "0877 8628 5954";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hello Tropical Vanilla Co., I would like to request a quote for premium Indonesian vanilla."
)}`;

export const EMAIL = "info@tropicalvanilla.id";
export const SALES_EMAIL = "sales@tropicalvanilla.id"

export const SPEC_SHEET = {
  en: "/tropical-vanilla-spec-sheet-en.pdf",
  id: "/tropical-vanilla-spec-sheet-id.pdf",
};

export const SOCIALS = {
  instagram:
    "https://www.instagram.com/tropicalvanillaid/?igsh=MTc4eDUwY2JwNDJmeA%3D%3D&utm_source=qr",
  tiktok: "https://www.tiktok.com/@tropicalvanillaid?is_from_webapp=1&sender_device=pc",
  facebook: "https://www.facebook.com/share/1DfpUnyrao/?mibextid=wwXIfr",
  maps: "https://maps.app.goo.gl/HisaF6GWXEpavxV58",
};

export const LOCATION = {
  label: "Tropical Vanilla Co.",
  address:
    "Gunungan, Pleret, Kec. Pleret, Kabupaten Bantul, Daerah Istimewa Yogyakarta 55791, Indonesia",
  directions: "https://maps.app.goo.gl/HisaF6GWXEpavxV58",
  embed:
    "https://maps.google.com/maps?q=Tropical+Vanilla+Co.,+Gunungan,+Pleret,+Bantul+Regency,+Special+Region+of+Yogyakarta+55791&z=16&output=embed",
};

export const IMG = {
  hero: "/generated/hero_drying.png",
  harvesting: "/generated/process_harvesting.png",
  curing: "/generated/process_curing.png",
  sorting: "/generated/process_sorting.png",
  packaging: "/generated/process_packaging.png",
  export: "/generated/process_export.png",
  beans: "/generated/product_beans.png",
  extract: "/generated/product_extract.png",
  powder: "/generated/product_powder.png",
  seed: "/generated/product_seed.png",
  paste: "/generated/Vanilla_Paste.png",
  flower: "/generated/quality_flower.png",
  landscape: "/generated/gallery_landscape.png",
  crate: "/generated/gallery_beans_crate.png",
  farmer: "/generated/about_farmer.png",
  logo: "/logo.png",
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Products", id: "products" },
  { label: "Quality", id: "quality" },
  { label: "Process", id: "process" },
  { label: "Gallery", id: "gallery" },
  { label: "Contact", id: "contact" },
];

export const FEATURES = [
  {
    icon: "Sparkles",
    title: "Premium Quality",
    text: "Carefully selected beans with high vanillin content and optimal moisture.",
  },
  {
    icon: "Leaf",
    title: "Sustainable Sourcing",
    text: "Working directly with local farmers using sustainable and ethical practices.",
  },
  {
    icon: "PackageCheck",
    title: "Reliable Supply",
    text: "Consistent quality and supply all year round to support your business.",
  },
  {
    icon: "Ship",
    title: "Export Expertise",
    text: "Complete export documentation and professional service you can trust.",
  },
];

export const PRODUCTS = [
  {
    name: "Vanilla Beans — Grade A",
    tag: "Gourmet",
    image: IMG.beans,
    text: "Long, glossy, oil-rich gourmet pods hand-graded for exceptional aroma and flavour.",
    specs: [
      ["Moisture", "30 – 35%"],
      ["Vanillin", "> 2%"],
      ["Length", "16 – 20 cm"],
    ],
  },
  {
    name: "Vanilla Extract",
    tag: "Liquid",
    image: IMG.extract,
    text: "Natural, slow-extracted vanilla made from premium Indonesian beans for pure, rounded taste.",
    specs: [
      ["Type", "Single-fold"],
      ["Base", "Natural"],
      ["Use", "Bakery & dairy"],
    ],
  },
  {
    name: "Vanilla Powder",
    tag: "Ground",
    image: IMG.powder,
    text: "Finely ground whole beans — perfect for bakeries, ice cream, chocolate and beverages.",
    specs: [
      ["Grind", "Fine"],
      ["Purity", "100% bean"],
      ["Shelf life", "24 months"],
    ],
  },
  {
    name: "Vanilla Seed (Caviar)",
    tag: "Caviar",
    image: IMG.seed,
    text: "Tiny black vanilla caviar seeds harvested from split pods — the pure aromatic heart of the vanilla bean.",
    specs: [
      ["Form", "Loose seeds"],
      ["Purity", "100% seed"],
      ["Use", "Pastry, ice cream, confectionery"],
    ],
  },
  {name: "Vanilla Paste",
   tag: "Paste",
   image:IMG.paste,
   text: "Rich and aromatic paste made from premium Indonesian beans for convenient use in baking and confectionery",
   specs: [
     ["Form", "Bold Paste"],
     ["Base", "Powder mix with glycerin"],
     ["Use", "Dessert, bakery, ice cream"],
   ],
  },
];

export const PROCESS = [
  {
    no: "01",
    title: "Harvesting",
    image: IMG.harvesting,
    text: "Every pod is hand-picked at perfect maturity, ensuring the deepest concentration of flavour before curing begins.",
  },
  {
    no: "02",
    title: "Curing & Fermentation",
    image: IMG.curing,
    text: "Beans are sun-cured and sweated in a traditional cycle over weeks, developing their rich, dark aroma naturally.",
  },
  {
    no: "03",
    title: "Sorting & Grading",
    image: IMG.sorting,
    text: "Each bean is measured, inspected and graded by hand so every bundle we ship meets a single, consistent standard.",
  },
  {
    no: "04",
    title: "Packaging",
    image: IMG.packaging,
    text: "Vacuum-sealed in food-grade packaging within a hygienic facility to lock in moisture, aroma and freshness.",
  },
  {
    no: "05",
    title: "Export",
    image: IMG.export,
    text: "On-time worldwide delivery with complete export documentation, handled end-to-end by our team.",
  },
];

export const QUALITY_SPECS = [
  "Moisture content: 30 – 35%",
  "Vanillin content: > 2% (Grade A)",
  "Microbial & pesticide tested",
  "Compliant with international food-safety standards",
  "Full traceability from farm to port",
];

export const GALLERY = [
  { image: IMG.farmer, alt: "Farmer holding vanilla pods" },
  { image: IMG.hero, alt: "Vanilla drying racks" },
  { image: IMG.sorting, alt: "Sorting cured vanilla beans" },
  { image: IMG.packaging, alt: "Packing vanilla for export" },
  { image: IMG.crate, alt: "Crates of vanilla ready for export" },
  { image: IMG.landscape, alt: "Tropical vanilla plantation" },
];
